import { useState } from "react";
import { hotRank } from "@/mocks/homeData";

const tabs = ["飙升榜", "热议榜", "发酵中榜"];

export default function HotRank() {
  const [active, setActive] = useState(0);

  return (
    <section id="rank" className="mx-auto w-full max-w-6xl scroll-mt-20 px-4 py-12 md:px-6 md:py-16">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
        <div>
          <p className="text-xs font-medium uppercase tracking-widest text-primary-600">实时热度</p>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            热度飙升 · 一屏看懂谁在刷屏
          </h2>
          <p className="mt-2 max-w-xl text-sm leading-relaxed text-foreground-600">
            榜单约每 15 分钟更新，综合公开讨论热度与传播节奏，标出最值得点进来看的那几件事。
          </p>
        </div>
        <div className="inline-flex w-fit items-center rounded-full border border-secondary-200 bg-background-50 p-1">
          {tabs.map((tab, idx) => (
            <button
              key={tab}
              type="button"
              onClick={() => setActive(idx)}
              className={`rounded-full px-4 py-1.5 text-sm font-medium transition-colors whitespace-nowrap ${
                active === idx
                  ? "bg-primary-500 text-background-50"
                  : "text-foreground-700 hover:text-foreground-950"
              }`}
            >
              {tab}
            </button>
          ))}
        </div>
      </div>

      <div className="mt-8 grid gap-6 lg:grid-cols-12">
        <div className="space-y-3 lg:col-span-7">
          {hotRank.map((item) => (
            <article
              key={item.rank}
              className="group flex items-center gap-3 rounded-lg border border-background-200/70 bg-background-100/60 p-3 transition-colors hover:border-primary-200 hover:bg-background-100 md:gap-4 md:p-4"
            >
              <span
                className={`w-8 shrink-0 text-center font-heading text-2xl font-bold md:w-10 ${
                  item.rank <= 3 ? "text-primary-500" : "text-secondary-400"
                }`}
              >
                {String(item.rank).padStart(2, "0")}
              </span>
              <div className="min-w-0 flex-1">
                <h3 className="truncate text-sm font-semibold text-foreground-900 group-hover:text-primary-700 md:text-base">
                  {item.title}
                </h3>
                <p className="mt-1 flex flex-wrap items-center gap-2">
                  <span className="inline-flex items-center gap-1 rounded-full bg-accent-100 px-2 py-0.5 text-xs text-accent-900">
                    <i className="ri-price-tag-3-line" />
                    {item.tag}
                  </span>
                  <span className="hidden text-xs text-secondary-500 sm:inline">
                    热度 {item.heat}
                  </span>
                </p>
              </div>
              <div className="shrink-0 text-right">
                <p className={`text-sm font-semibold ${item.up ? "text-primary-600" : "text-secondary-500"}`}>
                  {item.heat}
                </p>
                <p
                  className={`mt-0.5 inline-flex items-center gap-0.5 text-xs font-medium ${
                    item.up ? "text-primary-600" : "text-secondary-400"
                  }`}
                >
                  <i className={`${item.up ? "ri-arrow-up-line" : "ri-arrow-down-line"}`} />
                  {item.delta}
                </p>
              </div>
            </article>
          ))}
        </div>

        <aside className="lg:col-span-5">
          <div className="rounded-lg border border-background-200/70 bg-secondary-50 p-5 md:p-6">
            <div className="flex items-center justify-between">
              <h3 className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-950">
                <i className="ri-fire-line text-primary-500" />
                本期热词包
              </h3>
              <span className="inline-flex items-center gap-1.5 text-xs text-secondary-600">
                <span className="h-1.5 w-1.5 rounded-full bg-primary-500 animate-pulse-dot" />
                实时滚动
              </span>
            </div>
            <div className="mt-4 flex flex-wrap gap-2">
              {[
                { w: "当事人是谁", hot: true },
                { w: "身份起底", hot: true },
                { w: "旧料翻出", hot: true },
                { w: "背景深扒", medium: true },
                { w: "关联人物", medium: true },
                { w: "履历核实", hot: true },
                { w: "首曝溯源" },
                { w: "社交账号查找", medium: true },
                { w: "同框交集" },
                { w: "代称对应" },
              ].map((t) => (
                <span
                  key={t.w}
                  className={`inline-flex items-center rounded-md px-3 py-1.5 text-xs font-medium transition-colors ${
                    t.hot
                      ? "bg-primary-500 text-background-50"
                      : t.medium
                        ? "bg-accent-500 text-foreground-950"
                        : "bg-background-50 text-foreground-700 ring-1 ring-secondary-200"
                  }`}
                >
                  {t.w}
                </span>
              ))}
            </div>

            <div className="mt-6 space-y-3 border-t border-secondary-200 pt-5">
              <p className="text-sm font-semibold text-foreground-900">榜单判定说明</p>
              {[
                ["ri-time-line", "多平台公开讨论热度加权"],
                ["ri-arrow-up-double-line", "单位时间传播增速优先"],
                ["ri-zoom-in-line", "点名与实名线索齐全度加分"],
                ["ri-alarm-line", "新增进展自动上浮"],
              ].map(([icon, text]) => (
                <p key={text} className="flex items-center gap-2 text-sm text-foreground-600">
                  <i className={`${icon} text-primary-500`} />
                  {text}
                </p>
              ))}
            </div>

            <a
              href="#archives"
              className="mt-6 flex items-center justify-center gap-2 rounded-md bg-foreground-950 px-4 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-foreground-800 whitespace-nowrap"
            >
              查看事件档案
              <i className="ri-arrow-right-s-line" />
            </a>
          </div>
        </aside>
      </div>
    </section>
  );
}